var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        return _vm.openMissingInfoPopup();
      }
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }